import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { rootRouteRef, viewHelmReleaseRouteRef } from './routes';
import { helmReleasesApiRef } from './api';
import { DefaultApiClient } from '@internal/plugin-helmreleases-common';

import {
  ApiBlueprint,
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';

const helmReleasesPage = PageBlueprint.make({
  name: 'HelmReleasesPage',
  params: {
    path: '/helmreleases',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: () =>
      import('./components/HelmReleaseComponent').then(m =>
        compatWrapper(<m.HelmReleaseComponent />),
      ),
  },
});

const helmreleaseApi = ApiBlueprint.make({
  name: 'helmreleases',
  params: defineParams =>
    defineParams({
      api: helmReleasesApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new DefaultApiClient({ discoveryApi, fetchApi }),
    }),
});

export const helmreleasesPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'helmreleases',
  extensions: [helmreleaseApi, helmReleasesPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
    viewHelmRelease: viewHelmReleaseRouteRef,
  }),
});
